import { PageHeader } from "@/components/common";
import { OffersRow } from "@/components/OffersRow";
import { useTx } from "@/components/PaymentPanel";

export default function Plans() {
  const tx = useTx();
  return (
    <div data-testid="plans-page">
      <PageHeader eyebrow={tx("My Plans", "Mes offres")} title={tx("Sidebizz plans", "Les offres Sidebizz")} subtitle={tx("See what you have and what you can add next.", "Voyez ce que vous avez et ce que vous pouvez ajouter.")} />
      <OffersRow />
    </div>
  );
}
